<template>
    <div class="profit-detail">
        <div class="profit-title">
            <div class="title-line"></div>
            <span class="title-content">收益明细</span>
        </div>
        <el-table
            :data="profitList"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: '#F9F9F9' }"
        >
            <el-table-column label="日期">
                <template slot-scope="scope">
                    <span>{{ $util.fmtDate(scope.row.profitdate) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持仓收益(元)" align="center">
                <template slot-scope="scope">
                    <span :class="scope.row.currentprofit < 0 ? 'down' : ''">
                        {{ $util.fmtNum(scope.row.currentprofit) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="累计收益(元)" align="center">
                <template slot-scope="scope">
                    <span :class="scope.row.totalprofit < 0 ? 'down' : ''">
                        {{ $util.fmtNum(scope.row.totalprofit) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="持仓份额(份)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.totalfundvol) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="当日收益(元)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.dailyyield) }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="pagination-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataRefresh"
            />
        </el-row>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";

export default {
    name: "ProfitDetail",
    components: {},
    mixins: [mixin],
    props: {
        fundcode: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            allPage: "",
            curPage: 1,
            profitList: []
        };
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
    },
    methods: {
        // 获取收益明细
        async getProfitDetail() {
            const _x = {
                fundcode: this.fundcode,
                rangetype: "0",
                sort: "desc",
                pagenum: this.curPage,
                pagesize: 10
            };
            const res = await fundApi.qryHistoryProfit(_x);
            if (res.data) {
                this.allPage = res.data.total.toString();
                this.profitList = res.data.data;
            }
        },
        // 切换分页
        dataRefresh() {
            this.getProfitDetail();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.profit-detail {
    box-sizing: border-box;
    margin-bottom: 24px;
    .profit-title {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }
}
.el-table {
    border: 1px solid #f1f1f1;
}
.el-table--fit {
    margin-bottom: 0;
}
.el-table td.el-table__cell div {
    color: #333333;
}
.el-table td.el-table__cell span {
    color: #333333;
}
.el-table td.el-table__cell .up {
    color: $risk5;
}
.el-table td.el-table__cell .down {
    color: $risk1;
}
.pagination-box {
    text-align: center;
    padding: 10px 0 0;
}
.el-pagination {
    margin-bottom: 0;
}
</style>
